import { render, staticRenderFns } from "./Act_tmp.vue?vue&type=template&id=0658c075&scoped=true"
import script from "./Act_tmp.vue?vue&type=script&lang=js"
export * from "./Act_tmp.vue?vue&type=script&lang=js"
import style0 from "./Act_tmp.vue?vue&type=style&index=0&id=0658c075&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658c075",
  null
  
)

export default component.exports